var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownAlternateDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 16px / dropdown-alternate-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon / 16px / dropdown-alternate",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5L6.69842 9.88436C7.4474 10.5263 8.5526 10.5263 9.30158 9.88436L15 5H11.9268L8 8.36584L4.07318 5H1Z",
    fill: "#7898FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownAlternateDown);
export default __webpack_public_path__ + "static/media/dropdown-alternate-down.753c4b692ac62b04a6e4d3519dd46369.svg";
export { ForwardRef as ReactComponent };